import {includes, isNil, isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

interface KeepModelsOfSelectedMakesParams {
  selectedModels: string[];
  selectedMakes: string[];
  /**
   * The catalogue options for the makes selected *before* the change, which is what maps each
   * already-selected model back to its make.
   */
  modelOptions: Array<{value: string; make: string}> | Nullish;
}

/**
 * Drops the models whose make is no longer selected, so a narrowed make selection cannot leave
 * unreachable models behind in the scope.
 *
 * While the catalogue options are missing (still loading, or the request failed) there is nothing
 * to map the models against, so the selection is left untouched — pruning against no options at
 * all would silently empty it.
 */
export function keepModelsOfSelectedMakes(params: KeepModelsOfSelectedMakesParams) {
  if (isNil(params.modelOptions)) {
    return params.selectedModels;
  }

  return params.selectedModels.filter((model) => {
    const modelOption = params.modelOptions?.find((option) => option.value === model);

    return isNotNil(modelOption) && includes(modelOption.make, params.selectedMakes);
  });
}
